<template>
    <div>
        <Header />
        <main class="app-content">
            <div class="app-title">
                <div>
                    <h1><i class="fa fa-dashboard"></i>SAHA CARİ DURUMU</h1>
                </div>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
                    <li class="breadcrumb-item"><a href="#"></a></li>
                </ul>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <form>
                        <div class="form-group">
                            <label class="control-label">AÇIKLAMA:</label>
                            <input v-model="result.content" class="form-control" type="text"
                                style="max-width: 100%;" placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS" />
                        </div>
                        <div class="form-group">
                            <label class="control-label">TUTAR:</label>
                            <input v-model="result.total" class="form-control" type="text"
                                style="max-width: 100%;" placeholder="Alınan Ödeme Miktarı" />
                        </div>
                        <div class="form-group">
                            <label class="control-label">BANKA:</label>
                            <input v-model="result.bank" class="form-control" type="text"
                                style="max-width : 100%" placeholder="Ödemenin Alındığı Banka Hesabımız" />
                        </div>
                        <div class="form-group">
                            <label class="control-label">TARİH:</label>
                            <input v-model="result.date" class="form-control" type="date"
                                style="max-width: 100%;" placeholder="Ödeme Alınan Tarihi Giriniz" />
                        </div>
                        <div>
                            <button @click="sendData()" type="button" class="btn btn-success">ÖDEMEYİ KAYDET</button>
                        </div>
                    </form>
                </div>
                <div class="col-lg-6 col-md-6">
                    <form>
                        <div class="form-group">
                            <label class="control-label">TOPLAM HAKEDİŞ:</label>
                            <div class="form-control" type="text"
                                style="max-width: 100%; background-color : #86e972" placeholder="Yapılan Ödeme Hakkında Detay ÇEK-NAKİT VS" >{{datas.hakedilen_tutar}}</div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">TOPLAM GELEN ÖDEME:</label>
                            <div class="form-control" type="text"
                                style="max-width: 100%; background-color : #f3e661" placeholder="Alınan Ödeme Miktarı" >{{datas.toplamalinan}}</div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">KALAN NET TUTAR:</label>
                            <div class="form-control" type="text"
                                style="max-width : 100%; background-color : #e96e6e" placeholder="Ödemenin Alındığı Banka Hesabımız" >{{datas.kalannetodeme}}</div>
                        </div>
                    </form>
                </div>
            </div>
            <br>
            <div class="row center">
                <div class="col-md-12 -webkit-scrollbar ">
                    <div class="hr-title-home hr-long center">
                        <abbr>
                            <h2>ÖDEME GEÇMİŞİ</h2>
                        </abbr>
                    </div>
                    <div style="height: 850px; overflow-y: overlay">
                        <!-- class="tileHomepage"  yukarı dive eklenirse arka plan gelir-->
                        <div class="col--12 sidenav">
                            <div v-for="(item, index) in result" :key="index" class="col-md-12 col-lg-12 hower1"
                                style="margin-bottom: 10px">

                                <br />
                                <a @click="routeDetailNotifications(item.id)" style="font-size: 14px " class="readmore">
                                    <!-- @click="routeDetailNotifications(item.id)" yukarı a etiketinden sonra eklenirse tıklanabilir -->
                                    <div class="block-blog text-left">
                                        <div class="content-blog">
                                            <!-- <a style="font-size: 14px" class="readmore" v-html="'<div>' + item.content + '</div>'"></a> -->
                                            <a style="font-size: 14px" class="readmore" v-html="">{{item.bank}} - {{
                                                item.total }} </a>
                                            <a style="
                      overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;X
                    -webkit-box-orient: vertical;
                  " v-html="'<div>' + item.content + '</div>'"></a>
                                            <a>{{ item.user_name }} -
                                                {{ item.regdate }}</a>
                                            <hr />
                                        </div>
                                    </div>

                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </main>

        <Sidebar />
    </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";

export default {
    data() {
        return {
            buttonid: "",
            result: [],
            result2: [],
            situation: false,
            img_base_url: store.state.img_base_url,
            saha_idm: this.$route.query.idm,
            saha_id2: this.$route.query.idm,
        };
    },
    methods: {
        sendData: function () {
            // if (!this.result.noticetitle) {
            //     this.$swal({
            //         text: "Lütfen Not Başlığı Giriniz!",
            //         icon: "error",
            //         closeOnClickOutside: false,
            //     });
            //     return false;
            // } else if (!this.result.noticecontent) {
            //     this.$swal({
            //         text: "Lütfen Not Açıklamasını Giriniz!!",
            //         icon: "error",
            //         closeOnClickOutside: false,


            //     });
            // } else if (!this.result.noticecontent) {
            //     this.$swal({
            //         text: "Lütfen Not Açıklamasını Giriniz!!",
            //         icon: "error",
            //         closeOnClickOutside: false,


            //     });
            // } else if (!this.result.noticecontent) {
            //     this.$swal({
            //         text: "Lütfen Not Açıklamasını Giriniz!!",
            //         icon: "error",
            //         closeOnClickOutside: false,


            //     });
            //     return false;
            // }
            var url = store.state.base_url + "AslanSahalar/createPayment.php?key=123";

            var datas = {
                id: localStorage.getItem("id"),
                token: localStorage.getItem("token"),
                // sectionsId: localStorage.getItem("sectionsId"),
                date: this.result.date,
                total: this.result.total,
                bank: this.result.bank,
                user_id: this.user_id,
                content: this.result.content,
                saha_idm: this.saha_idm.substr(0, 3),
            };
            axios
                .post(url, JSON.stringify(datas))
                .then((response) => {
                    if (response.data.data == true) {
                        this.$swal({
                            text: "Not Başarıyla Eklendi!",
                            icon: "success",
                            closeOnClickOutside: true,
                        });
                        setTimeout(() => {
                            location.reload();
                        }, 1000);

                    }

                    ////conso.log(response);
                })
                .catch((error) => {
                    //conso.log(error.response);
                });
        },
        routeAddNote: function () {
            this.$router.push("addNotice");
        },

        reload: function () {
            location.reload();
        },
        routeDetailNotices: function (itemId) {
            window.location.href = "#/noticesDetail?id=" + itemId;
        },
        routeDetailNotifications: function (itemId) {
            window.location.href = "#/notesDetailSaha?id=" + itemId;
        },
    },

    mounted: function () {
        let datas = [];
        this.buttonid = localStorage.getItem("id");
        let url = store.state.base_url + "AslanSahalar/getAllCariSaha.php?key=123";
        var sendData = {
            id: localStorage.getItem("id"),
            token: localStorage.getItem("token"),
            saha_idm: this.saha_idm.substr(0, 3),
        };

        axios
            .post(url, JSON.stringify(sendData))
            .then((response) => {
                this.result = response.data.data;
                this.datas = response.data.datas;
            })
            .catch((err) => {
                console.log(err.response);
            });
    },
    components: {
        Header,
        Sidebar,
    },
};
</script>
<style scoped>
.hower1:hover {
    background: #c1163b;

    color: white;
}

.hower2:hover {
    background: #1bbd0d;

    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Cari.vue